export interface Mainref {
  refid?: string,
  refemail?: string,
  refprefix?: string,
  reffirstname?: string,
  reflastname?: string,
  refcompany?: string,
  scope?: string,
  phone?: string,
  lang?: string,
}